export default {
  body: "'Mukta', 'sans-serif'",
  heading: "'Saira', 'sans-serif'",
};
